import { useQuery } from '@tanstack/react-query';

import {
  creditCapacityQueryOptions,
  paymentAccountDetailQueryOptions,
} from '@lib/query/options/payment';
import { convertToLocale } from '@lib/util/money';

export const NormalSettlementSummary = () => {
  const { data: accountDetail, isLoading, isError } = useQuery(
    paymentAccountDetailQueryOptions()
  );
  const {
    data: creditCapacity,
    isLoading: isCreditCapacityLoading,
    isError: isCreditCapacityError,
  } = useQuery(creditCapacityQueryOptions());

  if (isLoading || isCreditCapacityLoading) return null;

  if (isError || isCreditCapacityError) {
    return (
      <div className="border-white-40 mb-8 grid min-h-[98px] w-full grid-cols-1 items-center rounded-md border">
        <div className="text-grey-60 h-full px-4 py-6 text-center">
          無法取得帳戶資訊，請稍後再試
        </div>
      </div>
    );
  }

  if (!accountDetail) return null;

  return (
    <div className="border-white-40 mb-8 grid min-h-[98px] w-full grid-cols-1 items-center rounded-md border" data-testid="deposit-balance-container">
      <div className="h-full px-4 py-6">
        <span className="text-black-10 mr-2 text-base">當前儲值金餘額</span>
        <span className="text-black-40 text-xl font-bold" data-testid="deposit-balance-total">
          {convertToLocale({
            amount:
              accountDetail.cashBalance +
              accountDetail.rewardBalance +
              accountDetail.refundBalance,
            currency_code: 'twd',
          })}
        </span>
        <br />
        <span className="text-grey-60 text-sm">
          {`= 儲值金 `}
          <span data-testid="deposit-balance-cash">{convertToLocale({
            amount: accountDetail.cashBalance,
            currency_code: 'twd',
          })}</span>
          {` + 儲值回饋金 `}
          <span data-testid="deposit-balance-reward">{convertToLocale({
            amount: accountDetail.rewardBalance,
            currency_code: 'twd',
          })}</span>
          {` + 退貨回饋金 `}
          <span data-testid="deposit-balance-refund">{convertToLocale({
            amount: accountDetail.refundBalance,
            currency_code: 'twd',
          })}</span>
        </span>
      </div>
      {!!(
        accountDetail.loanOutstandingBalance &&
        accountDetail.loanOutstandingBalance > 0
      ) && (
        <>
          <div className="h-full px-4 py-6">
            <span className="text-black-10 mr-2 text-base">賒帳欠款金額</span>
            <span className="text-black-40 text-xl font-bold" data-testid="deposit-loan-outstanding">
              {convertToLocale({
                amount: accountDetail.loanOutstandingBalance,
                currency_code: 'twd',
              })}
            </span>
            <br />
          </div>
          <div className="h-full px-4 py-6">
            <span className="text-black-10 mr-2 text-base">未兌現票據總額</span>
            <span className="text-black-40 text-xl font-bold" data-testid="deposit-expected-amount">
              {convertToLocale({
                amount: creditCapacity?.expectedDepositAmount || 0,
                currency_code: 'twd',
              })}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default NormalSettlementSummary;
